import type { PortfolioGroupEditModel, PortfolioGroupListItem } from "../models/portfolio-group";
import { portfolioGroupsClient } from "./api-clients";

export const portfolioGroupsApi = {
  getPortfolioGroups(signal?: AbortSignal): Promise<PortfolioGroupListItem[]> {
    return portfolioGroupsClient.getPortfolioGroups(signal);
  },
  createPortfolioGroup(model: PortfolioGroupEditModel): Promise<PortfolioGroupListItem> {
    return portfolioGroupsClient.createPortfolioGroup(model);
  },
  updatePortfolioGroup(portfolioGroupId: number, model: PortfolioGroupEditModel): Promise<PortfolioGroupListItem> {
    return portfolioGroupsClient.updatePortfolioGroup(portfolioGroupId, model);
  },
  deletePortfolioGroup(portfolioGroupId: number): Promise<void> {
    return portfolioGroupsClient.deletePortfolioGroup(portfolioGroupId);
  },
};
